import React from 'react'
import Prism from 'prismjs';
import Button from '@mui/material/Button';
import { ReactReduxContext } from 'react-redux'
import ClipboardJS from 'clipboard';

import { renderEmailString } from "./emailString";
import config from "../config";

var beautify = require('js-beautify').html;

const gutterStyle = {
    padding: '1em 0.75em',
    textAlign: 'right',
    color: '#75715e',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    userSelect: 'none',
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: '1em',
    lineHeight: '1.5',
    flexShrink: 0,
    minWidth: '2.5em',
    backgroundColor: '#272822',
};

const Html = () => {
    let htmlCodeRef = React.createRef();
    let validateHTMLInputRef = React.createRef();
    let validateHTMLFormRef = React.createRef();

    React.useEffect(() => {
        new ClipboardJS('#copyButton');
    });

    const handleValidateHTMLSubmit = () => {
        validateHTMLInputRef.current.value = htmlCodeRef.current.innerText;
        validateHTMLFormRef.current.submit();
    };

    return (
        <ReactReduxContext.Consumer>
            {({ store }) => {
                const beautified = beautify(
                    renderEmailString(store),
                    { indent_size: 2, space_in_empty_paren: true }
                );
                const lines = beautified.split('\n');
                const highlighted = Prism.highlight(beautified, Prism.languages.html, 'html');

                return (
                    <div>
                        <Button variant="contained"
                            data-clipboard-target="#htmlString" id="copyButton" color="secondary">
                            Copy to clipboard
                        </Button>
                        <form target="_blank"
                            encType="multipart/form-data" method="POST" action={config["validation-server"]}
                            ref={validateHTMLFormRef}
                            style={{display: 'inline-block', paddingLeft: '5px'}}
                        >
                            <input type="hidden" name="content" ref={validateHTMLInputRef}/>
                        </form>
                        <div style={{ display: 'flex', overflowX: 'auto', marginTop: 8 }}>
                            <div style={gutterStyle}>
                                {lines.map((_, i) => <div key={i}>{i + 1}</div>)}
                            </div>
                            <pre className="language-html" style={{ margin: 0, flex: 1, overflow: 'visible', borderRadius: 0 }}>
                                <code
                                    className="language-html"
                                    id="htmlString"
                                    ref={htmlCodeRef}
                                    dangerouslySetInnerHTML={{ __html: highlighted }}
                                />
                            </pre>
                        </div>
                    </div>
                );
            }}
        </ReactReduxContext.Consumer>
    );
}

export default Html;
